<template>
 <div class="online-car-wrap">
    <div class="top-wrap">
        <div class="text-wrap">
            <div class="title">花骑士代驾</div>
            <div class="sub-title">
                花骑士代驾系统创新升级，多端登录；及时掌控，精准里程数；AI智能派单，高效卓越；阶梯式价格表，科学合理；稳定的司机调度，实时通讯技术，全程保姆式指导。
            </div>
        </div>
        <img src="../assets/banner_img.png" alt="">
    </div>
    <!-- ============================== -->
    <!-- <div class="business-title">业务能力</div> -->
       <div class="business-list-wrap">
        <div class="title-wrap">传统代驾现状</div>
        <el-row :gutter="10">
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[0].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[0].title}}</div>
                    <div class="content">{{solutions[0].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[1].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[1].title}}</div>
                    <div class="content">{{solutions[1].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[2].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[2].title}}</div>
                    <div class="content">{{solutions[2].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[3].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[3].title}}</div>
                    <div class="content">{{solutions[3].content}}</div>
                </div>
            </el-col>
        </el-row>
        <div class="title-wrap">客户端功能</div>
        <div class="user-end-wrap">
            <img class="img-1" src="../assets/onlineCar/onlineCarbg1.png" alt="">
            <img class="img-2" src="../assets/onlineCar/onlineCarbg2.png" alt="">
            <img class="img-3" src="../assets/onlineCar/onlineCarbg3.png" alt="">
            <img class="img-4" src="../assets/onlineCar/onlineCarbg4.png" alt="">
            <img class="img-5" src="../assets/onlineCar/onlineCarbg5.png" alt="">
        </div>
        <div class="title-wrap">司机端功能</div>
        <div class="user-end-wrap">
            <img class="img-6" src="../assets/onlineCar/onlineCarbg6.png" alt="">
            <img class="img-8" src="../assets/onlineCar/onlineCarbg8.png" alt="">
            <img class="img-7" src="../assets/onlineCar/onlineCarbg7.png" alt="">
        </div>
        <div class="title-wrap">后台管理</div>
        <div class="user-end-wrap">
            <img class="img-1" src="../assets/onlineCar/onlineCarbg1.png" alt="">
            <img class="img-2" src="../assets/onlineCar/onlineCarbg2.png" alt="">
            <img class="img-9" src="../assets/onlineCar/onlineCarbg3-1.png" alt="">
            <img class="img-10" src="../assets/onlineCar/onlineCarbg3-2.png" alt="">
            <!-- <img class="img-11" src="../assets/onlineCar/onlineCarbg7.png" alt=""> -->
        </div>
       </div>
    
 </div>
</template>

<script>
export default {
  data () {
    return {
        solutions: [
                    {
                        // img: require('../../src/assets/online/online_1.png'),
                        img: require('../assets/daijia/daijia_1.png'),
                        title: "收费标准不统一",
                        content: "传统代驾，没有贴切的代驾运用系统，一口价方式进行收费，收费标准杂乱"
                    },
                    {
                        img: require('../assets/daijia/daijia_2.png'),
                        title: "运营成本高",
                        content: "电话呼叫，多客服接听来进行司机调度，司机位置不明确等导致代驾运营成本高"
                    }, {
                        img: require('../assets/daijia/daijia_3.png'),
                        title: "品牌推广落地难",
                        content: "没有合理的平台，落地推广依赖微信朋友圈推广，造成了用户对品牌的意识低"
                    },
                    {
                        img: require('../assets/daijia/daijia_4.png'),
                        title: "客户精准营销难",
                        content: "传统代驾公司，通常没办法精准记录用户细信息，从而导致二次营销难以进行"
                    },
                    // {
                    //     img: require('../../src/assets/business/business_5.png'),
                    //     title: "仓库管理",
                    //     content: "支持自营商品的出库、入库，仓库中各商品库存数量管理"
                    // },
                    // {
                    //     img: require('../../src/assets/business/business_6.png'),
                    //     title: "纸电联动",
                    //     content: "纸书和电子书自动进行关联，相互促进"
                    // },  {
                    //     img: require('../../src/assets/business/business_7.png'),
                    //     title: "丰富前端表现",
                    //     content: "支持APP、H5多前端业务表现形式"
                    // },
                    // {
                    //     img: require('../../src/assets/business/business_8.png'),
                    //     title: "统计报表",
                    //     content: "支持用户、商品、订单多维度可视化报表"
                    // },
                ],
    }
  },
  computed: {
  },
  mounted() {
  },
}

</script>
<style scoped lang="scss">
   .online-car-wrap{
       .top-wrap{
           height: 450px;
           background: #466dff;
           display: flex;
           align-items: center;
           justify-content: center;
           .text-wrap{
               width: 450px;
               // background: orange;
               margin-right: 50px;
               color: white;
               .title{
                   font-size: 24px;
                   margin-bottom: 20px;
               }
               .sub-title{
                   font-size: 16px;
               }
           }
       }
       .business-list-wrap{
        // width:70%;
        width:100%;
        margin: 20px auto;
            .solu_img_border {
                margin-top: 15px;
                margin-bottom: 20px;
                width: 80px;
                height: 80px
            }
            .border_img_parent{
                // border: 1px solid red;
                display: flex;
                justify-content: center;
                // margin: 20px auto;
            }
        .title{
            text-align: center;
            font-size: 20px;
            color: #363636;
            margin-bottom: 10px;
        }   
        .content{
            text-align: center;
            font-size: 16px;
            color: #97A1AB;
            margin: 20px auto;
            width: 80%;
            // background: orange;
        } 
       }
       .title-wrap{
        margin: 30px auto;
        height: 20px;
        text-align: center;
        // background: orange;
        font-size: 30px;
        font-weight: 600;
        color: #466dff;
       }
       .user-end-wrap{
        margin-top: 130px;
        position: relative;
        height: 600px;
        width: 100%;
        .img-1{
            position: absolute;
            left: 100px;
            top: 0px;
            width: 667px;
            height: 589px;
        }
        .img-2{
            position: absolute;
            right: 0px;
            top: 0px;
            width: 389px;
            height: 536px;
        }
        .img-3{
            position: absolute;
            left: 300px;
            top: 0px;
            width: 289px;
            height: 590px;
        }
        .img-4{
            position: absolute;
            left: 700px;
            top: 200px;
            width: 106px;
            height: 85px;
        }
        .img-5{
            position: absolute;
            left: 850px;
            top: 20px;
            width: 600px;
            height: 450px;
        }
        .img-6{
            position: absolute;
            left: 200px;
            top: 20px;
            width: 700px;
            height: 550px;
        }
        .img-7{
            position: absolute;
            right: 250px;
            top: 20px;
            width: 289px;
            height: 590px;
        }
        .img-8{
            position: absolute;
            right: 100px;
            top: 20px;
            width: 667px;
            height: 590px;
        }
        .img-9{
            position: absolute;
            left: 200px;
            top: 50px;
            width: 548px;
            height: 430px;
        }
        .img-10{
            position: absolute;
            right: 500px;
            top: 50px;
            width: 548px;
            height: 430px;
        }
       }
   }
</style>
